import { CustomImage } from 'components/common/imgComponents/CustomImg/styles';

import hidePasswordImg from './static_assets/hide_password_icon.svg';
import showPasswordImg from './static_assets/show_password_icon.svg';

export const ShowPasswordIcon = () => <CustomImage src={showPasswordImg} height="14px" width="18px" />;
export const HidePasswordIcon = () => <CustomImage src={hidePasswordImg} height="16px" width="18px" />;
